import React, {
    useContext,
    useState,
    useEffect,
    useMemo,
    useRef,
    useCallback,
} from 'react'
import styled from 'styled-components'
import {
    Grid2,
    CardContent,
    Typography,
    Modal,
    Box,
    Button,
    MenuItem,
    Tooltip,
    Menu,
    Fade,
    Table,
    TableContainer,
    TableHead,
    Divider,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
    Skeleton,
    FormGroup,
    FormControlLabel,
    Checkbox,
    CircularProgress,
    Snackbar,
} from '@mui/material'
import {Await, useNavigate} from 'react-router-dom'
import {HistoryContext} from '../../../contexts/history'
import ProjetoVazio from '../../../assets/projeto-vazio.svg'
import NOprojectSelected from '../../../assets/noProjectSelected.svg'
import Pasta from '../../../assets/ClosedFile.svg'
import PastaAberta from '../../../assets/OpenedeFile.svg'
import PastaAdicionar from '../../../assets/PlusFile.svg'
import Arquivo from '../../../assets/Arquivo.png'
import Coins from '../../../assets/coins.svg'
import Teste from '../../../assets/teste.svg'
import {DocumentApi} from '../../../services/DocumentApi.service'
import {project} from '../../../types/project'
import Alert from '@mui/material/Alert'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined'
import CloseIcon from '@mui/icons-material/Close'
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined'
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined'
import AddSharpIcon from '@mui/icons-material/AddSharp'
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt'
import InfoIcon from '@mui/icons-material/Info'
import DoneIcon from '@mui/icons-material/Done'
import ScienceIcon from '@mui/icons-material/Science'
import EditIcon from '@mui/icons-material/Edit'
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'
import {getCurrentColors, getSubdomain} from '../../../utils/colors'
import {StatusBadge} from '../../../components/StatusBadge'
import {getCurrentImages} from '../../../utils/logos'

const COLORS = getCurrentColors()
const IMAGES = getCurrentImages()

const Page = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    position: relative;
    scroll-behavior: smooth;
    flex: 1;
    background-color: #f6f8fa;
`

const Container = styled.div`
    max-height: calc(100vh);
    flex-direction: column;
    display: flex;
    justify-content: flex-start;
    margin-left: 20px;
    overflow-y: auto;
    box-sizing: border-box;
`
const FolderContainer = styled.div`
    background-color: #ffffff;
    max-width: 340px;
    height: 100vh;
    flex-direction: column;
    display: flex;
    justify-content: flex-start;
    padding-left: 20px;
    padding-right: 20px;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    border-right: 1px solid #ccc;

    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
`

const DocumentsContainer = styled.div`
    max-height: 100vh;
    width: 100%;
    flex-direction: column;
    display: flex;
    justify-content: flex-start;
    overflow-y: auto;
    box-sizing: border-box;
    padding-left: 40px;
`

const CardContainer = styled.div<{isSelected?: boolean}>`
    width: 100%;
    height: 90px;
    border: 1px solid #ccc;
    border-radius: 14px;
    overflow: hidden;
    cursor: pointer;
    background-color: ${(props) =>
        props.isSelected ? '#F5F9FE' : 'transparent'};
    border-color: ${(props) =>
        props.isSelected ? COLORS.primariaEscura : '#ccc'};
    transition:
        background-color 0.2s ease,
        border-color 0.2s ease,
        transform 0.2s ease;
    align-items: center;
    justify-content: flex-start;

    &:hover {
        background-color: ${(props) =>
            props.isSelected ? '#F5F9FE' : '#fafafa'};
        border-color: ${COLORS.primariaEscura};
        transform: translateY(-2px) scale(1.01);
    }

    &:active {
        transform: translateY(0) scale(1);
    }
`

const CardDocumentContainer = styled.div`
    width: 255px;
    height: 150px;
    margin-top: 20px;
    border: 1px solid #ccc;
    border-radius: 14px;
    overflow: hidden;
    border-color: #d1d1d1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding: 12px;
    box-sizing: border-box;
    gap: 8px;
    transition:
        border-color 0.2s ease,
        transform 0.2s ease;

    &:hover {
        border-color: ${COLORS.primariaEscura};
        transform: translateY(-2px) scale(1.01);
    }

    &:active {
        transform: translateY(0) scale(1);
    }
`

const CardHead = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    margin-top: 16px;
    padding-left: 10px;
    color: #000f35;
`

const CardBody = styled(CardContent)`
    height: 200px;
    display: flex !important;
    flex-direction: column !important;
    cursor: pointer;
    align-items: flex-start;
    overflow: hidden;
    margin-left: 4px;
`

const TruncatedTypography = styled(Typography)`
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    max-height: 60px;
    word-break: break-word;
`

const CardFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: left;
    margin-left: 20px;
    height: 50px;
`

const ProjectActionButton = styled(Button)`
    && {
        margin-top: 20px;
        background-color: transparent;
        color: ${COLORS.primariaEscura};
        border: 1px solid ${COLORS.primariaEscura};
        border-radius: 14px;
        box-shadow: none;
        transition:
            transform 0.2s ease,
            background-color 0.2s ease,
            color 0.2s ease;
    }

    &&:hover {
        background-color: ${COLORS.primariaEscura};
        color: #ffffff;
        border: 1px solid ${COLORS.primariaEscura};
        box-shadow: none;
        transform: translateY(-2px) scale(1.01);
    }

    &&:active {
        transform: translateY(0) scale(1);
    }
`

const SelectedSchiefMessage = styled.span`
    padding-top: 28px;
    font-size: 24px;
    text-align: start;
    font-weight: 700;
    color: #1f2b3a;
`

const ModalContent = styled(Box)`
    background: #fff;
    border-radius: 14px;
    padding: 20px;
    min-height: 232px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
`

const UnarchiveModalContent = styled.div`
    background-color: white;
    border-radius: 14px;
    width: 100%;
    max-width: 80%;
    max-height: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 24px;
    outline: none;
    display: flex;
    flex-direction: column;

    @media (min-width: 768px) {
        /* Para tablets e maiores */
        width: 60%;
    }

    @media (min-width: 1024px) {
        /* Para telas de desktop */
        width: 40%;
    }
`

const Header = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-left: 16px;
    margin-bottom: 16px;
    margin-top: 16px;
    font-size: 18px;
    color: #707070;
`

const HeadModal = styled.div`
    display: flex;
    padding: 20px;
    justify-content: space-between;
`

const BodyModal = styled.div`
    aling-content: center;
    display: flex;
    padding: 20px;
    overflow-y: auto;
`
const ContentStatus = styled.div`
    color: white;
    background-color: #ffa500;
    padding: 6px;
    border-radius: 100px;
    font-size: 14px;
    text-align: center;
    max-width: 85px;
`
const ContentDot = styled.div`
    display: flex,
    align-items: center,
    gap: 5px,
    margin-right: 5px,
`

const Dot = styled.div<{isActive?: boolean}>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${(props) => (props.isActive ? '#000000' : '#707070')};
    flex-shrink: 0;
`
const TitleListDocument = styled(Typography)<{isActive?: boolean}>`
    font-size: 14px;
    color: ${(props) => (props.isActive ? '#000000' : '#707070')};
    weight: ${(props) => (props.isActive ? '500' : '400')};
`

const Loader = styled.div`
    text-align: center;
    padding: 10px;
    color: red;
`

const StyledIconButton = styled(IconButton)``

export default function Projetos() {
    const {
        projectArray: contextHistoryArray,
        getNextQuestion,
        postProject,
        setQuestionArray,
        questionArray,
        limits,
        archiveProject,
        getProjects,
        unarchieveModal,
        archivedProjects,
        unarchiveProject,
        setUnarchieveModal,
        userDocumentsInfo,
        updateProject,
        projectCost,
        setProjectCost,
        webSocketMessage,
        setViewResume,
    } = useContext(HistoryContext)
    const [pcspPopupOpen, setPcspPopupOpen] = useState(false)
    const [isModalOpen, setModalOpen] = useState(false)
    const [selectedDocumentType, setSelectedDocumentType] = useState<string[]>(
        []
    )
    const [documentName, setDocumentName] = useState('')
    const [isLoading, setIsLoading] = useState(true)
    const navigate = useNavigate()
    const api = useMemo(() => new DocumentApi(), [])
    const getProjectDisplayName = (name?: string) =>
        name?.trim() || 'Projeto sem nome'
    const getDocumentDisplayName = (name?: string) =>
        name?.trim() || 'Documento sem nome'
    const [openAlertErro, setOpenAlertErro] = React.useState(false)
    const [selectedProject, setSelectedProject] = useState<project>()
    const [newProject, setNewProject] = useState(false)
    const [newSelectedDocumentsType, setNewSelectedDocumentsType] = useState<
        string[]
    >([])

    const [selectedDocumentsType, setSelectedDocumentsType] = useState<
        string[]
    >([])
    const [projectById, setProjectById] = useState<project | null>(null)
    const [loadSelectedProject, setLoadSelectedProject] = useState(false)
    const [isCreatingProject, setIsCreatingProject] = useState(false)
    const [isCloneModalOpen, setIsCloneModalOpen] = useState(false)
    const [cloneProjectName, setCloneProjectName] = useState('')
    const [cloneSelectedDocuments, setCloneSelectedDocuments] = useState<
        string[]
    >([])
    const [projectToClone, setProjectToClone] = useState<project | null>(null)

    const [projectArrayPage, setProjectArrayPage] = useState(1)
    const [projectArray, setProjectArray] =
        useState<project[]>(contextHistoryArray)
    const [errorMessage, setErrorMessage] = useState<string | null>(null)

    const limit = 15
    const loaderRef = useRef<HTMLDivElement>(null)

    const loadMoreItems = useCallback(async () => {
        try {
            const newThreads = await api.getProjects(
                limit,
                projectArrayPage * limit
            )

            if (newThreads.length > 0) {
                setProjectArray((prevArray) => [...prevArray, ...newThreads])
                setProjectArrayPage((prevPage) => prevPage + 1)
            }
        } catch (error) {
            console.error('Failed to load more items:', error)
            setErrorMessage('Failed to load more items. Please try again.')
        }
    }, [projectArrayPage, limit])

    useEffect(() => {
        console.log('info documents', userDocumentsInfo?.document_types)
    }, [userDocumentsInfo])

    useEffect(() => {
        setProjectArray(contextHistoryArray)
    }, [contextHistoryArray])

    useEffect(() => {
        if (getSubdomain() === 'pcsp') {
            setPcspPopupOpen(true)
        }
    }, [])

    useEffect(() => {
        const fetchProjects = async () => {
            setIsLoading(true)
            await getProjects()
            setIsLoading(false)
        }
        fetchProjects()
    }, [])

    useEffect(() => {
        if (
            webSocketMessage.status === 'FINISHED' ||
            webSocketMessage.status === 'PENDING' ||
            webSocketMessage.description.includes('Error')
        ) {
            getSelectedProject(webSocketMessage.project_id)
        }
    }, [webSocketMessage])

    // useEffect(() => {
    //     if (questionArray.length > 0) {
    //         navigate('/gerador')
    //     }
    // }, [questionArray])

    const handleDocumentTypeChange = (id: string, depends?: string[]) => {
        const currentSelected =
            (newProject ? newSelectedDocumentsType : selectedDocumentsType) ||
            []

        let newSelectedArray: string[]

        if (currentSelected.includes(id)) {
            newSelectedArray = currentSelected.filter((item) => item !== id)
        } else {
            newSelectedArray = [...currentSelected, id]
        }

        if (!newProject) {
            setSelectedDocumentsType(newSelectedArray)
        } else {
            setNewSelectedDocumentsType(newSelectedArray)
        }

        console.log(
            'selectedDocumentsType (state before update):',
            selectedDocumentsType
        )
    }

    const handleOpenModal = () => {
        if (limits.usages.projects.current < limits.usages.projects.max) {
            setModalOpen(true)
            return
        }
        console.log('Limite de projetos atingido')
        setOpenAlertErro(true)
    }

    const handleCloseModal = () => {
        setModalOpen(false)
        setDocumentName('')
        setSelectedDocumentType([])
    }

    const handleEdit = async (project_id: string, project_name: string) => {
        console.log('Edit clicked for project:', project_id)
        const res = await api.getNextQuestion(project_id)
        localStorage.setItem('questionArray', JSON.stringify([res]))
        localStorage.setItem('projectId', JSON.stringify(project_id))
        localStorage.setItem('projectName', JSON.stringify(project_name))
        setQuestionArray([res])
        navigate('/gerador')
    }

    const handleResume = async () => {
        setViewResume(true)
        navigate('/gerador')
    }

    const handleOpenCloneModal = (project: project) => {
        setProjectToClone(project)
        setCloneProjectName(`${getProjectDisplayName(project.name)} - Cópia`)
        const documentType = project.documents
            .filter((doc) => doc.status === 'FINISHED')
            .map((doc) => doc.document_type)
        setCloneSelectedDocuments(documentType)
        setIsCloneModalOpen(true)
    }

    const handleCloseCloneModal = () => {
        setIsCloneModalOpen(false)
        setCloneProjectName('')
        setCloneSelectedDocuments([])
        setProjectToClone(null)
    }

    const handleCloneDocumentToggle = (document_type: string) => {
        setCloneSelectedDocuments((prev) => {
            if (prev.includes(document_type)) {
                return prev.filter((id) => id !== document_type)
            } else {
                return [...prev, document_type]
            }
        })
    }

    const cloneProject = async () => {
        if (
            !projectToClone ||
            !cloneProjectName ||
            cloneSelectedDocuments.length === 0
        ) {
            return
        }

        setIsCreatingProject(true)
        try {
            const body = {
                document_types: cloneSelectedDocuments,
                name: cloneProjectName,
            }
            const res = await api.cloneProject(projectToClone.id, body)
            console.log('Cloned project response:', res)
            await getProjects()
            getSelectedProject(res.project_id)
            setSelectedDocumentsType([])
            handleCloseCloneModal()
        } catch (error) {
            console.error('Error cloning project:', error)
        } finally {
            setIsCreatingProject(false)
        }
    }

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setUnarchieveModal(false)
        setAnchorEl(null)
    }
const formatDate = (dateString: string): string => {
    const normalized =
        dateString.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(dateString)
            ? dateString
            : dateString + 'Z'
    const date = new Date(normalized)

    return new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'America/Sao_Paulo',
    }).format(date)
}
    const handleConfirm = async () => {
        setIsCreatingProject(true)
        try {
            if (newProject) {
                const projectData = {
                    name: documentName,
                    project_type_id: '899704fd-10be-4aac-8b36-cafccc3f0f0a',
                    document_types: newProject
                        ? newSelectedDocumentsType || []
                        : selectedDocumentsType || [],
                }

                const res = await api.postProject(projectData)
                console.log('handle', res)
                localStorage.setItem('questionArray', JSON.stringify([res]))
                localStorage.setItem(
                    'projectName',
                    JSON.stringify(documentName)
                )
                localStorage.setItem(
                    'projectId',
                    JSON.stringify(res.project_id)
                )
                setQuestionArray([res])
            } else {
                const projectData = {
                    project_id: selectedProject?.id || '',
                    document_types: selectedDocumentsType || [],
                }
                await updateProject(projectData)

                if (selectedProject?.id) {
                    await getSelectedProject(selectedProject.id)
                }
            }
            handleCloseModal()
            setIsCreatingProject(false)
            if (newProject) {
                navigate('/gerador')
            }
        } catch (error) {
            console.error('Error creating project:', error)
        }
    }

    const handleDownload = async (project: project, index: number) => {
        setViewResume(false)
        console.log('Download clicked for project:', index)
        if (project.status === 'INCOMPLETE') {
            handleEdit(project.id, getProjectDisplayName(project.name))
        } else if (project.documents[index].path) {
            {
                await api.downloadDocument(
                    project.id,
                    project.documents[index].id,
                    project.documents[index].name
                )
            }
        } else {
            console.log('Download clicked for project:', project.id)
        }
    }

    useEffect(() => {
        const cachedProjectId = localStorage.getItem('projectId')
        if (cachedProjectId && projectArray.length > 0) {
            try {
                const projectId = JSON.parse(cachedProjectId)
                const cachedProject = projectArray.find(
                    (project) => project.id === projectId
                )
                if (cachedProject) {
                    setSelectedProject(cachedProject)
                    getSelectedProject(cachedProject.id)
                }
            } catch (error) {
                console.error('Error parsing cached project ID:', error)
            }
        }
    }, [projectArray])

    const getSelectedProject = async (projectId: string) => {
        setLoadSelectedProject(true)
        const res = await api.getProjectById(projectId)
        setSelectedProject(res)
        setProjectById(res)
        setLoadSelectedProject(false)
    }

    useEffect(() => {
        console.log('selecionado', selectedProject)
        if (selectedProject?.id) {
            const incompleteDocuments = selectedProject.documents.filter(
                (doc) => doc.status === 'INCOMPLETE'
            )
            setProjectCost(incompleteDocuments.length)
            console.log('incompleteDocuments', incompleteDocuments)
            console.log('Project cost:', projectCost)
            localStorage.setItem(
                'projectId',
                JSON.stringify(selectedProject?.id)
            )
        }
    }, [selectedProject])

    const archiveProject_ = async (project_id: string) => {
        try {
            const idToArchive = selectedProject?.id || project_id
            await archiveProject(idToArchive)

            try {
                await getProjects()
            } catch (err) {
                console.warn(
                    'Falha ao atualizar lista de projetos após arquivar',
                    err
                )
            }

            const remaining = projectArray.filter((p) => p.id !== idToArchive)
            if (remaining.length > 0) {
                setSelectedProject(remaining[0])
                setProjectById(remaining[0])
            } else {
                setSelectedProject(undefined)
                setProjectById(null)
            }
        } catch (error) {
            console.error('Erro ao arquivar projeto:', error)
        } finally {
            console.log('archiveProject', project_id)
        }
    }

    const _desarquivarModal = () => {
        return (
            <Modal
                onClose={handleClose}
                open={unarchieveModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                disablePortal
                disableEnforceFocus
            >
                <UnarchiveModalContent>
                    <HeadModal>
                        <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                        >
                            Documentos arquivados
                        </Typography>
                        <StyledIconButton onClick={handleClose}>
                            <CloseIcon />
                        </StyledIconButton>
                    </HeadModal>
                    <Divider orientation="horizontal" flexItem />
                    <BodyModal>
                        <TableContainer component={Box}>
                            <Table
                                sx={{minWidth: 200}}
                                aria-label="simple table"
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Nome</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Data de criação</TableCell>
                                        <TableCell align="right"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {archivedProjects?.map((item) => (
                                        <TableRow
                                            key={item.id}
                                            sx={{
                                                '&:last-child td, &:last-child th':
                                                    {border: 0},
                                            }}
                                        >
                                            <TableCell
                                                component="th"
                                                scope="row"
                                            >
                                                <ArticleOutlinedIcon
                                                    sx={{marginRight: '10px'}}
                                                />
                                                {item.name}
                                            </TableCell>
                                            <TableCell align="center">
                                                {item.status === 'FINISHED' ? (
                                                    <Typography
                                                        variant="body2"
                                                        style={{
                                                            maxWidth: '60px',
                                                            color: 'white',
                                                            backgroundColor:
                                                                '#007AFF',
                                                            padding: '6px',
                                                            borderRadius:
                                                                '100px',
                                                        }}
                                                    >
                                                        Pronto
                                                    </Typography>
                                                ) : (
                                                    <ContentStatus>
                                                        <Typography variant="body2">
                                                            Incompleto
                                                        </Typography>
                                                    </ContentStatus>
                                                )}
                                            </TableCell>
                                            <TableCell align="left">
                                                {formatDate(item.created_at)}
                                            </TableCell>
                                            <TableCell align="right">
                                                <IconButton
                                                    onClick={() =>
                                                        unarchiveProject(
                                                            item.id
                                                        )
                                                    }
                                                >
                                                    <UnarchiveOutlinedIcon />
                                                </IconButton>
                                                {
                                                    // <IconButton>
                                                    //     <DeleteOutlinedIcon
                                                    //         onClick={() =>
                                                    //             deleteThread(
                                                    //                 item.guid
                                                    //             )
                                                    //         }
                                                    //     />
                                                    // </IconButton>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </BodyModal>
                </UnarchiveModalContent>
            </Modal>
        )
    }

    const [documentMenuAnchor, setDocumentMenuAnchor] =
        useState<null | HTMLElement>(null)
    const [selectedDocumentIndex, setSelectedDocumentIndex] = useState<
        null | number
    >(null)
    return (
        <Page>
            <Snackbar
                slotProps={{
                    content: {
                        sx: {
                            backgroundColor: COLORS.primariaEscura,
                        },
                    },
                }}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                open={pcspPopupOpen}
                onClose={() => setPcspPopupOpen(false)}
                message="O time da Licito.guru segue aprimorando e calibrando o gerador de documentos.Seu feedback é muito bem-vindo."
                key={'topcenter'}
                action={
                    <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={() => setPcspPopupOpen(false)}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                }
            />
            {isLoading ? (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                    }}
                >
                    <Container style={{marginTop: '25px'}}>
                        <Grid2
                            style={{
                                borderRight: '1px solid grey',
                                maxWidth: '350px',
                            }}
                            container
                            rowSpacing={2}
                            columnSpacing={3}
                        >
                            {[...Array(10)].map((_, index) => (
                                <Grid2 key={index} size="auto">
                                    <CardContainer>
                                        <Skeleton
                                            variant="rectangular"
                                            width={255}
                                            height={118}
                                        />
                                    </CardContainer>
                                </Grid2>
                            ))}
                        </Grid2>
                    </Container>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '85%',
                            height: '100%',
                        }}
                    >
                        <div
                            style={{
                                width: '60%',
                                height: '60%',
                                backgroundColor: '#f5f5f5',
                                borderRadius: '12px',
                                border: '1px solid #e0e0e0',
                            }}
                        />
                    </div>
                </div>
            ) : projectArray.length === 0 ? (
                <div
                    style={{
                        textAlign: 'center',
                        margin: '0 auto',
                        height: '80%',
                        overflowY: 'auto',
                        maxWidth: '90%',
                        marginTop: '10%',
                    }}
                >
                    <img
                        src={ProjetoVazio}
                        alt="Projeto Vazio"
                        style={{maxWidth: '100%', height: 'auto'}}
                    />
                    <Typography
                        variant="h4"
                        color="textPrimary"
                        style={{marginTop: '-40px'}}
                    >
                        Ops, parece que você ainda não criou um documento
                    </Typography>
                    <Typography
                        variant="h6"
                        color="textSecondary"
                        style={{marginTop: '10px'}}
                    >
                        Aqui você pode ver a listagem, status e criar novos
                        documentos.
                    </Typography>
                    <Button
                        style={{
                            marginTop: '20px',
                            color: '#fff',
                        }}
                        variant="contained"
                        onClick={() => {
                            handleOpenModal()
                            setNewProject(true)
                            setViewResume(false)
                        }}
                    >
                        Criar novo Projeto
                    </Button>
                </div>
            ) : (
                <>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: '100%',
                        }}
                    >
                        <FolderContainer>
                            <SelectedSchiefMessage>
                                Meus documentos
                            </SelectedSchiefMessage>
                            <Typography
                                variant="body2"
                                sx={{color: '#5b6b7b', mb: 3}}
                                maxWidth={'330px'}
                            >
                                Aqui você pode ver a listagem, status e criar
                                novos documentos.
                            </Typography>
                            <Grid2 container rowSpacing={2} columnSpacing={3}>
                                <CardContainer
                                    style={{
                                        backgroundColor: COLORS.primariaEscura,
                                        color: 'black',
                                        display: 'flex',
                                        alignItems: 'center',
                                        flexDirection: 'row',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => {
                                        handleOpenModal()
                                        setNewProject(true)
                                    }}
                                >
                                    <img
                                        src={PastaAdicionar}
                                        alt="Projeto Vazio"
                                        style={{
                                            maxWidth: '100%',
                                            height: 'auto',
                                            marginRight: '10px',
                                            marginLeft: '19px',
                                        }}
                                    />
                                    <span
                                        style={{
                                            fontSize: '16px',
                                            fontWeight: '500',
                                            color: '#FFFFFF',
                                        }}
                                    >
                                        Novo projeto
                                    </span>
                                    <AddSharpIcon
                                        style={{
                                            color: '#FFFFFF',

                                            marginLeft: 'auto',
                                            marginRight: '16px',
                                        }}
                                    />
                                </CardContainer>

                                {projectArray.map((project) => {
                                    const projectName =
                                        project.name?.trim() ||
                                        'Projeto sem nome'

                                    return (
                                        <Grid2
                                            key={project.id}
                                            size="auto"
                                            style={{width: '100%'}}
                                        >
                                        <CardContainer
                                            isSelected={
                                                project.id ===
                                                selectedProject?.id
                                            }
                                            onClick={() => {
                                                if (
                                                    selectedProject?.id !==
                                                    project.id
                                                ) {
                                                    getSelectedProject(
                                                        project.id
                                                    )
                                                    setSelectedDocumentsType([])
                                                }
                                            }}
                                        >
                                            <CardHead
                                                style={{marginTop: '18px'}}
                                            >
                                                <img
                                                    src={
                                                        selectedProject?.id ===
                                                        project.id
                                                            ? IMAGES.pasta
                                                            : Pasta
                                                    }
                                                    alt="Projeto Vazio"
                                                    style={{
                                                        maxWidth: '100%',
                                                        height: 'auto',
                                                        marginRight: '8px',
                                                    }}
                                                />
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'start',
                                                    }}
                                                >
                                                    <Tooltip
                                                        title={projectName}
                                                    >
                                                        <span
                                                            style={{
                                                                fontFamily:
                                                                    'Inter',
                                                                fontSize:
                                                                    '16px',
                                                                fontWeight:
                                                                    '500',
                                                                color: '#292D32',
                                                            }}
                                                        >
                                                            {projectName
                                                                .length > 70
                                                                ? `${projectName.substring(
                                                                      0,
                                                                      70
                                                                  )}...`
                                                                : projectName}
                                                        </span>
                                                    </Tooltip>
                                                    {/* <Typography
                                                        variant="subtitle1"
                                                        align="center"
                                                        color="#5E5E5E"
                                                        sx={{
                                                            whiteSpace:
                                                                'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow:
                                                                'ellipsis',
                                                            maxWidth: '180px',
                                                        }}
                                                    >
                                                        {
                                                            project.documents.filter(
                                                                (doc) =>
                                                                    doc.status !==
                                                                    'NOT_STARTED'
                                                            ).length
                                                        }{' '}
                                                        documentos
                                                    </Typography> */}
                                                </div>
                                                <div
                                                    style={{marginLeft: 'auto'}}
                                                >
                                                    <Button
                                                        id="fade-button"
                                                        aria-controls={
                                                            open
                                                                ? 'fade-menu'
                                                                : undefined
                                                        }
                                                        aria-haspopup="true"
                                                        aria-expanded={
                                                            open
                                                                ? 'true'
                                                                : undefined
                                                        }
                                                        onClick={(event) =>
                                                            handleClick(event)
                                                        }
                                                    >
                                                        <MoreVertIcon />
                                                    </Button>
                                                    <Menu
                                                        id="fade-menu"
                                                        MenuListProps={{
                                                            'aria-labelledby':
                                                                'long-button',
                                                        }}
                                                        anchorEl={anchorEl}
                                                        open={open}
                                                        onClose={handleClose}
                                                        TransitionComponent={
                                                            Fade
                                                        }
                                                        PaperProps={{
                                                            style: {
                                                                boxShadow:
                                                                    'none',
                                                                backgroundColor:
                                                                    '#f5f5f5',
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem
                                                            onClick={() => {
                                                                handleClose()
                                                                archiveProject_(
                                                                    project.id
                                                                )
                                                            }}
                                                        >
                                                            Arquivar{' '}
                                                            <ArchiveOutlinedIcon />
                                                        </MenuItem>
                                                    </Menu>
                                                </div>
                                            </CardHead>
                                        </CardContainer>
                                        </Grid2>
                                    )
                                })}
                                {projectArray.length >= limit && (
                                    <div
                                        style={{
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            marginTop: '16px',
                                        }}
                                    >
                                        <Button
                                            style={{
                                                width: '100%',
                                                marginBottom: '20px',
                                            }}
                                            variant="outlined"
                                            onClick={loadMoreItems}
                                        >
                                            Carregar mais
                                        </Button>
                                    </div>
                                )}
                            </Grid2>
                        </FolderContainer>
                        <DocumentsContainer>
                            {loadSelectedProject ? (
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'flex-start',
                                        width: '100%',
                                        marginTop: '20px',
                                    }}
                                >
                                    <Skeleton
                                        variant="text"
                                        width={200}
                                        height={40}
                                        style={{marginBottom: '20px'}}
                                    />
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            flexWrap: 'wrap',
                                            gap: '10px',
                                            marginBottom: '20px',
                                        }}
                                    >
                                        {[...Array(3)].map((_, index) => (
                                            <Skeleton
                                                key={index}
                                                variant="rectangular"
                                                width={100}
                                                height={20}
                                                style={{borderRadius: '10px'}}
                                            />
                                        ))}
                                    </div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: '20px',
                                        }}
                                    >
                                        {[...Array(4)].map((_, index) => (
                                            <Skeleton
                                                key={index}
                                                variant="rectangular"
                                                width={255}
                                                height={150}
                                                style={{borderRadius: '8px'}}
                                            />
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <SelectedSchiefMessage>
                                        {projectById?.name}
                                    </SelectedSchiefMessage>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            flexWrap: 'wrap',
                                            gap: '10px',
                                        }}
                                    >
                                        {projectById?.documents.map((type) => (
                                            <div
                                                key={type.document_type}
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    gap: '5px',
                                                }}
                                            >
                                                <ContentDot>
                                                    {type.status ===
                                                        'NOT_STARTED' && (
                                                        <Dot />
                                                    )}
                                                    {type.status ===
                                                        'FINISHED' && (
                                                        <DoneIcon
                                                            style={{
                                                                color: '#23CB69',
                                                                fontSize:
                                                                    '16px',
                                                            }}
                                                        />
                                                    )}
                                                    {type.status ===
                                                        'INCOMPLETE' && (
                                                        <EditIcon
                                                            style={{
                                                                color: '#FF9500',
                                                                fontSize:
                                                                    '16px',
                                                            }}
                                                        />
                                                    )}
                                                    {(type.status ===
                                                        'PENDING' ||
                                                        type.status ===
                                                            'PARSING' ||
                                                        type.status ===
                                                            'GENERATING_DOCS') && (
                                                        <CircularProgress
                                                            size={15}
                                                            style={{
                                                                color: '#FFA500',
                                                                marginRight:
                                                                    '5px',
                                                            }}
                                                        />
                                                    )}
                                                </ContentDot>
                                                <TitleListDocument
                                                    isActive={true}
                                                >
                                                    {type.name}
                                                </TitleListDocument>
                                            </div>
                                        ))}
                                    </div>
                                    {selectedProject ? (
                                        <div>
                                            <Grid2
                                                style={{
                                                    overflow: 'auto',
                                                }}
                                                container
                                                rowSpacing={2}
                                                columnSpacing={3}
                                            >
                                                <CardDocumentContainer
                                                    style={{
                                                        backgroundColor:
                                                            COLORS.primariaEscura,
                                                        color: 'black',
                                                        display: 'flex',
                                                        justifyContent:
                                                            'space-around',
                                                        flexDirection: 'column',
                                                        cursor: 'pointer',
                                                    }}
                                                    onClick={() => {
                                                        if (
                                                            selectedProject?.status ===
                                                            'INCOMPLETE'
                                                        ) {
                                                            handleEdit(
                                                                selectedProject.id,
                                                                getProjectDisplayName(
                                                                    selectedProject.name
                                                                )
                                                            )
                                                        } else {
                                                            handleOpenModal()
                                                            setNewProject(false)
                                                        }
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'row',
                                                            justifyContent:
                                                                'space-between',
                                                            width: '100%',
                                                            padding: '0 15px',
                                                        }}
                                                    >
                                                        <img
                                                            src={Arquivo}
                                                            alt="Projeto Vazio"
                                                            style={{
                                                                borderRadius:
                                                                    '8px',
                                                                width: '46px',
                                                                height: '46px',
                                                                marginRight:
                                                                    '10px',
                                                            }}
                                                        />
                                                        <AddSharpIcon
                                                            style={{
                                                                color: '#ffffff',
                                                                marginBottom:
                                                                    '8px',
                                                            }}
                                                        />
                                                    </div>
                                                    <div
                                                        style={{
                                                            marginLeft: '16px',
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                fontSize:
                                                                    '16px',
                                                                fontWeight:
                                                                    '500',
                                                                color: '#ffffff',
                                                            }}
                                                        >
                                                            Novo documento
                                                        </span>
                                                    </div>
                                                </CardDocumentContainer>

                                                {projectById?.documents
                                                    ?.filter(
                                                        (project) =>
                                                            project.status !==
                                                            'NOT_STARTED'
                                                    )
                                                    .map((project, index) => (
                                                        <Grid2
                                                            key={project.id}
                                                            size="auto"
                                                            style={{
                                                                marginTop:
                                                                    'auto',
                                                            }}
                                                        >
                                                            <CardDocumentContainer>
                                                                <CardHead
                                                                    style={{
                                                                        marginTop: 0,
                                                                        paddingLeft: 0,
                                                                        alignItems:
                                                                            'stretch',
                                                                        justifyContent:
                                                                            'flex-start',
                                                                        height: '100%',
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            display:
                                                                                'flex',
                                                                            flexDirection:
                                                                                'column',
                                                                            alignItems:
                                                                                'flex-start',
                                                                            justifyContent:
                                                                                'space-between',
                                                                            width: '100%',
                                                                            height: '100%',
                                                                        }}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                display:
                                                                                    'flex',
                                                                                justifyContent:
                                                                                    'space-between',
                                                                                alignItems:
                                                                                    'center',
                                                                                width: '100%',
                                                                                minHeight:
                                                                                    '28px',
                                                                            }}
                                                                        >
                                                                            {project.status !==
                                                                                'NOT_STARTED' && (
                                                                                <StatusBadge
                                                                                    status={
                                                                                        project.status ===
                                                                                        'PARSING'
                                                                                            ? 'PROCESSING'
                                                                                            : project.status
                                                                                    }
                                                                                />
                                                                            )}
                                                                            {project.status && (
                                                                                <>
                                                                                    <IconButton
                                                                                        onClick={(
                                                                                            event
                                                                                        ) => {
                                                                                            event.stopPropagation()
                                                                                            setDocumentMenuAnchor(
                                                                                                event.currentTarget
                                                                                            )
                                                                                            setSelectedDocumentIndex(
                                                                                                index
                                                                                            )
                                                                                        }}
                                                                                        size="small"
                                                                                    >
                                                                                        <MoreVertIcon />
                                                                                    </IconButton>
                                                                                    <Menu
                                                                                        anchorEl={
                                                                                            documentMenuAnchor
                                                                                        }
                                                                                        open={
                                                                                            Boolean(
                                                                                                documentMenuAnchor
                                                                                            ) &&
                                                                                            selectedDocumentIndex ===
                                                                                                index
                                                                                        }
                                                                                        onClose={() => {
                                                                                            setDocumentMenuAnchor(
                                                                                                null
                                                                                            )
                                                                                            setSelectedDocumentIndex(
                                                                                                null
                                                                                            )
                                                                                        }}
                                                                                        TransitionComponent={
                                                                                            Fade
                                                                                        }
                                                                                        PaperProps={{
                                                                                            style: {
                                                                                                boxShadow:
                                                                                                    'none',
                                                                                                backgroundColor:
                                                                                                    '#f5f5f5',
                                                                                            },
                                                                                        }}
                                                                                    >
                                                                                        {selectedProject
                                                                                            ?.documents[
                                                                                            selectedDocumentIndex ??
                                                                                                -1
                                                                                        ]
                                                                                            ?.status ===
                                                                                            'INCOMPLETE' && (
                                                                                            <MenuItem
                                                                                                onClick={async () => {
                                                                                                    if (
                                                                                                        selectedProject &&
                                                                                                        selectedDocumentIndex !==
                                                                                                            null
                                                                                                    ) {
                                                                                                        await api.deleteDocument(
                                                                                                            selectedProject.id,
                                                                                                            selectedProject
                                                                                                                .documents[
                                                                                                                selectedDocumentIndex
                                                                                                            ]
                                                                                                                .document_type
                                                                                                        )
                                                                                                        await getSelectedProject(
                                                                                                            selectedProject.id
                                                                                                        )
                                                                                                    }
                                                                                                    setDocumentMenuAnchor(
                                                                                                        null
                                                                                                    )
                                                                                                    setSelectedDocumentIndex(
                                                                                                        null
                                                                                                    )
                                                                                                }}
                                                                                                disabled={
                                                                                                    projectById?.documents &&
                                                                                                    projectById.documents.filter(
                                                                                                        (
                                                                                                            doc
                                                                                                        ) =>
                                                                                                            doc.status !==
                                                                                                            'NOT_STARTED'
                                                                                                    )
                                                                                                        .length <=
                                                                                                        1
                                                                                                }
                                                                                            >
                                                                                                Apagar
                                                                                            </MenuItem>
                                                                                        )}
                                                                                        {selectedProject
                                                                                            ?.documents[
                                                                                            selectedDocumentIndex ??
                                                                                                -1
                                                                                        ]
                                                                                            ?.status ===
                                                                                            'FAILED' && (
                                                                                            <MenuItem
                                                                                                onClick={async () => {
                                                                                                    if (
                                                                                                        selectedProject &&
                                                                                                        selectedDocumentIndex !==
                                                                                                            null
                                                                                                    ) {
                                                                                                        await api.retryDocumentProcessing(
                                                                                                            selectedProject.id,
                                                                                                            selectedProject
                                                                                                                .documents[
                                                                                                                selectedDocumentIndex
                                                                                                            ]
                                                                                                                .id
                                                                                                        )

                                                                                                        await getSelectedProject(
                                                                                                            selectedProject.id
                                                                                                        )
                                                                                                    }
                                                                                                    setDocumentMenuAnchor(
                                                                                                        null
                                                                                                    )
                                                                                                    setSelectedDocumentIndex(
                                                                                                        null
                                                                                                    )
                                                                                                }}
                                                                                            >
                                                                                                Regerar
                                                                                            </MenuItem>
                                                                                        )}
                                                                                    </Menu>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                        <div
                                                                            style={{
                                                                                display:
                                                                                    'flex',
                                                                                flexDirection:
                                                                                    'column',
                                                                                alignItems:
                                                                                    'flex-start',
                                                                                justifyContent:
                                                                                    'flex-start',
                                                                                gap: '4px',
                                                                                width: '100%',
                                                                                minHeight:
                                                                                    '88px',
                                                                                cursor:
                                                                                    project.status ===
                                                                                        'FINISHED' ||
                                                                                    project.status ===
                                                                                        'INCOMPLETE'
                                                                                        ? 'pointer'
                                                                                        : 'default',
                                                                            }}
                                                                            onClick={() => {
                                                                                if (
                                                                                    project.status ===
                                                                                    'FINISHED'
                                                                                ) {
                                                                                    handleDownload(
                                                                                        projectById,
                                                                                        index
                                                                                    )
                                                                                } else if (
                                                                                    project.status ===
                                                                                    'INCOMPLETE'
                                                                                ) {
                                                                                    handleDownload(
                                                                                        projectById,
                                                                                        index
                                                                                    )
                                                                                }
                                                                            }}
                                                                        >
                                                                            <Tooltip
                                                                                title={
                                                                                    getDocumentDisplayName(
                                                                                        project.name
                                                                                    )
                                                                                }
                                                                            >
                                                                                <Typography
                                                                                    align="left"
                                                                                    fontSize="16px"
                                                                                    fontWeight="bold"
                                                                                    fontFamily="Inter"
                                                                                    color="#292D32"
                                                                                    sx={{
                                                                                        maxWidth:
                                                                                            '100%',
                                                                                        lineHeight:
                                                                                            '20px',
                                                                                        minHeight:
                                                                                            '40px',
                                                                                        display:
                                                                                            '-webkit-box',
                                                                                        WebkitLineClamp: 2,
                                                                                        WebkitBoxOrient:
                                                                                            'vertical',
                                                                                        overflow:
                                                                                            'hidden',
                                                                                        textOverflow:
                                                                                            'ellipsis',
                                                                                        wordBreak:
                                                                                            'break-word',
                                                                                    }}
                                                                                >
                                                                                    {getDocumentDisplayName(
                                                                                        project.name
                                                                                    )
                                                                                        .length >
                                                                                    35
                                                                                        ? `${getDocumentDisplayName(
                                                                                              project.name
                                                                                          ).slice(0, 35)}...`
                                                                                        : getDocumentDisplayName(
                                                                                              project.name
                                                                                          )}
                                                                                </Typography>
                                                                            </Tooltip>
                                                                            <Typography
                                                                                align="left"
                                                                                fontFamily="Inter"
                                                                                fontSize="14px"
                                                                                color="#5E5E5E"
                                                                                sx={{
                                                                                    whiteSpace:
                                                                                        'nowrap',
                                                                                    overflow:
                                                                                        'hidden',
                                                                                    textOverflow:
                                                                                        'ellipsis',
                                                                                    maxWidth:
                                                                                        '100%',
                                                                                }}
                                                                            >
                                                                                Atualizado
                                                                                em{' '}
                                                                                {formatDate(
                                                                                    project.updated_at
                                                                                )}
                                                                            </Typography>
                                                                            <div
                                                                                style={{
                                                                                    minHeight:
                                                                                        '24px',
                                                                                    display:
                                                                                        'flex',
                                                                                    alignItems:
                                                                                        'center',
                                                                                    justifyContent:
                                                                                        'flex-start',
                                                                                    width: '100%',
                                                                                }}
                                                                            >
                                                                                {project.status ===
                                                                                    'FINISHED' && (
                                                                                    <Typography
                                                                                        style={{
                                                                                            display:
                                                                                                'flex',
                                                                                            alignItems:
                                                                                                'center',
                                                                                            fontSize:
                                                                                                '14px',
                                                                                        }}
                                                                                        color={
                                                                                            COLORS.primariaEscura
                                                                                        }
                                                                                        variant="body2"
                                                                                        align="left"
                                                                                        sx={{
                                                                                            whiteSpace:
                                                                                                'nowrap',
                                                                                            overflow:
                                                                                                'hidden',
                                                                                            textOverflow:
                                                                                                'ellipsis',
                                                                                            maxWidth:
                                                                                                '100%',
                                                                                        }}
                                                                                    >
                                                                                        <SystemUpdateAltIcon
                                                                                            style={{
                                                                                                color: COLORS.primariaEscura,
                                                                                                marginRight:
                                                                                                    '5px',
                                                                                            }}
                                                                                        />
                                                                                        Download
                                                                                    </Typography>
                                                                                )}
                                                                                {project.status ===
                                                                                    'INCOMPLETE' && (
                                                                                    <Typography
                                                                                        style={{
                                                                                            display:
                                                                                                'flex',
                                                                                            alignItems:
                                                                                                'center',
                                                                                            fontSize:
                                                                                                '14px',
                                                                                        }}
                                                                                        color="#FFA500"
                                                                                        variant="body2"
                                                                                        align="left"
                                                                                        sx={{
                                                                                            whiteSpace:
                                                                                                'nowrap',
                                                                                            overflow:
                                                                                                'hidden',
                                                                                            textOverflow:
                                                                                                'ellipsis',
                                                                                            maxWidth:
                                                                                                '100%',
                                                                                        }}
                                                                                    >
                                                                                        <EditIcon
                                                                                            style={{
                                                                                                color: '#FFA500',
                                                                                                marginRight:
                                                                                                    '5px',
                                                                                            }}
                                                                                        />
                                                                                        Continuar
                                                                                    </Typography>
                                                                                )}
                                                                                {(project.status ===
                                                                                    'PROCESSING' ||
                                                                                    project.status ===
                                                                                        'GENERATING_DOCS' ||
                                                                                    project.status ===
                                                                                        'PARSING' ||
                                                                                    project.status ===
                                                                                        'PENDING') && (
                                                                                    <Typography
                                                                                        style={{
                                                                                            display:
                                                                                                'flex',
                                                                                            alignItems:
                                                                                                'center',
                                                                                            fontSize:
                                                                                                '14px',
                                                                                        }}
                                                                                        color="#FFA500"
                                                                                        variant="body2"
                                                                                        align="left"
                                                                                        sx={{
                                                                                            whiteSpace:
                                                                                                'nowrap',
                                                                                            overflow:
                                                                                                'hidden',
                                                                                            textOverflow:
                                                                                                'ellipsis',
                                                                                            maxWidth:
                                                                                                '100%',
                                                                                        }}
                                                                                    >
                                                                                        <CircularProgress
                                                                                            size={
                                                                                                20
                                                                                            }
                                                                                            style={{
                                                                                                color: '#FFA500',
                                                                                                marginRight:
                                                                                                    '5px',
                                                                                            }}
                                                                                        />
                                                                                        Gerando
                                                                                    </Typography>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </CardHead>
                                                            </CardDocumentContainer>
                                                        </Grid2>
                                                    ))}
                                            </Grid2>
                                            {selectedProject.documents.filter(
                                                (doc) =>
                                                    doc.status === 'FINISHED'
                                            ).length > 0 && (
                                                <div
                                                    style={{
                                                        width: '100%',
                                                        display: 'flex',
                                                        gap: '10px',
                                                        flexWrap: 'wrap',
                                                        marginTop: '20px',
                                                        borderTop:
                                                            '1px solid #E0E0E0',
                                                    }}
                                                >
                                                    <ProjectActionButton
                                                        onClick={() => {
                                                            if (
                                                                projectById?.id
                                                            ) {
                                                                api.downloadAllDocuments(
                                                                    projectById.id
                                                                )
                                                            }
                                                        }}
                                                    >
                                                        Baixar todos os
                                                        documentos
                                                    </ProjectActionButton>
                                                    <ProjectActionButton
                                                        onClick={() => {
                                                            if (
                                                                projectById?.id
                                                            ) {
                                                                handleResume()
                                                            }
                                                        }}
                                                    >
                                                        Resumo das Respostas
                                                    </ProjectActionButton>
                                                    <ProjectActionButton
                                                        onClick={() => {
                                                            if (projectById) {
                                                                handleOpenCloneModal(
                                                                    projectById
                                                                )
                                                            }
                                                        }}
                                                    >
                                                        Clonar Projeto
                                                    </ProjectActionButton>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                height: '100%',
                                            }}
                                        >
                                            <img
                                                src={NOprojectSelected}
                                                alt="Projeto Vazio"
                                                style={{
                                                    borderRadius: '8px',
                                                    maxWidth: '100%',
                                                    minWidth: '150px',
                                                    height: 'auto',
                                                    marginRight: '10px',
                                                }}
                                            />
                                            <span
                                                style={{
                                                    fontSize:
                                                        window.innerWidth < 1128
                                                            ? '20px'
                                                            : '24px',
                                                    fontWeight: 'bold',
                                                    color: '#000000DE',
                                                    minWidth: '150px',
                                                }}
                                            >
                                                Selecione um projeto para
                                                começar
                                            </span>
                                            <span
                                                style={{
                                                    fontSize:
                                                        window.innerWidth < 1128
                                                            ? '14px'
                                                            : '16px',
                                                    color: '#000000DE',
                                                    maxWidth: '475px',
                                                    textAlign: 'center',
                                                    minWidth: '150px',
                                                }}
                                            >
                                                Você já tem projetos criados.
                                                Clique em um deles para
                                                visualizar os documentos,
                                                acompanhar o status e continuar
                                                de onde parou.
                                            </span>
                                        </div>
                                    )}
                                </>
                            )}
                        </DocumentsContainer>
                        {openAlertErro && (
                            <Alert
                                style={{alignSelf: 'flex-end'}}
                                variant="filled"
                                severity="error"
                                onClose={() => {
                                    setOpenAlertErro(false)
                                }}
                            >
                                Seus Créditos para gerar documentos acabaram
                            </Alert>
                        )}
                    </div>
                </>
            )}

            <Modal
                open={isModalOpen}
                onClose={handleCloseModal}
                onKeyDown={(event) => {
                    if (
                        event.key === 'Enter' &&
                        selectedDocumentType &&
                        documentName
                    ) {
                        handleConfirm()
                    }
                }}
            >
                <ModalContent>
                    {
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <Typography
                                variant="h6"
                                gutterBottom
                                sx={{fontSize: '16px'}}
                            >
                                {newProject ? 'Novo Projeto' : 'Editar Projeto'}
                            </Typography>
                            <IconButton onClick={handleCloseModal}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                    }

                    {newProject && (
                        <>
                            <Typography
                                variant="subtitle1"
                                sx={{fontSize: '14px'}}
                                gutterBottom
                            >
                                Nome do projeto
                            </Typography>
                            <input
                                placeholder="Nome do projeto"
                                title="Nome do projeto"
                                id="projectName"
                                type="text"
                                value={documentName}
                                onChange={(e) =>
                                    setDocumentName(e.target.value)
                                }
                                style={{
                                    width: '100%',
                                    padding: '8px',
                                    borderRadius: '4px',
                                    border: '1px solid #ccc',
                                    fontSize: '16px',
                                }}
                                autoFocus
                            />
                        </>
                    )}

                    {documentName.length > 0 && documentName.length < 3 && (
                        <span style={{color: 'red'}}>
                            O nome do documento deve ter no mínimo 3 caracteres.
                        </span>
                    )}

                    {documentName.length > 190 && (
                        <span style={{color: 'red'}}>
                            O nome do documento deve ter no máximo 190
                            caracteres.
                        </span>
                    )}
                    <div style={{marginTop: '10px'}}>
                        <Typography
                            variant="subtitle1"
                            sx={{fontSize: '14px'}}
                            gutterBottom
                        >
                            Tipos de documento
                        </Typography>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '8px',
                            }}
                        >
                            {newProject && (
                                <FormGroup>
                                    {userDocumentsInfo?.document_types?.map(
                                        (docType) => (
                                            <FormControlLabel
                                                key={docType.id}
                                                control={
                                                    <Checkbox
                                                        checked={
                                                            newSelectedDocumentsType?.includes(
                                                                docType.id
                                                            ) || false
                                                        }
                                                        onChange={(e) => {
                                                            console.log(
                                                                'Checkbox changed:',
                                                                docType.id,
                                                                e.target.checked
                                                            )
                                                            handleDocumentTypeChange(
                                                                docType.id
                                                            )
                                                        }}
                                                    />
                                                }
                                                label={
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems:
                                                                'center',
                                                            gap: '4px',
                                                        }}
                                                    >
                                                        {docType.name}
                                                        <Tooltip
                                                            title={
                                                                docType.name.includes(
                                                                    'ETP'
                                                                )
                                                                    ? 'O Estudo Técnico Preliminar, conforme o artigo 6º, inciso XX, da Lei nº 14.133/2021, é um documento crucial na fase inicial do planejamento de contratações públicas. Ele serve para identificar e caracterizar o interesse público e selecionar a solução mais adequada para a necessidade governamental. O principal objetivo do ETP é fornecer base sólida para a construção do anteprojeto, termo de referência ou projeto básico, se a contratação for julgada viável.'
                                                                    : docType.name.includes(
                                                                            'DFD'
                                                                        )
                                                                      ? 'O Documento de Fluxo de Dados é um instrumento técnico essencial em diversas disciplinas, como a engenharia de software, gerência de projetos e análise de sistemas. Ele serve para mapear, visualizar e compreender o fluxo de informações dentro de processos ou sistemas, ilustrando como os dados se movem entre fontes e destinos.'
                                                                      : docType.name.includes(
                                                                              'TR'
                                                                          )
                                                                        ? 'O Termo de Referência é um documento fundamental no processo de contratações públicas, utilizado principalmente para a aquisição de bens e serviços. Serve como base detalhada para a preparação de licitações e contratos, descrevendo especificamente o que a Administração Pública pretende contratar.'
                                                                        : docType.name.includes(
                                                                                'Documento'
                                                                            )
                                                                          ? 'Documento genérico que pode ser utilizado para diversas finalidades dentro do processo de contratação pública, fornecendo informações específicas conforme a necessidade do projeto.'
                                                                          : docType.name.includes(
                                                                                  'Ata'
                                                                              )
                                                                            ? 'A Ata é um documento oficial que registra de forma resumida e clara os principais pontos discutidos e as decisões tomadas em reuniões, assembleias ou outros eventos formais.'
                                                                            : docType.name.includes(
                                                                                    'Contrato'
                                                                                )
                                                                              ? 'O Contrato é um documento jurídico que estabelece direitos e obrigações entre as partes, definindo termos, condições, prazos e responsabilidades para a execução de serviços ou fornecimento de bens.'
                                                                              : 'Documento adicional do projeto'
                                                            }
                                                            componentsProps={{
                                                                tooltip: {
                                                                    sx: {
                                                                        maxWidth:
                                                                            '400px',
                                                                        fontSize:
                                                                            '14px',
                                                                        padding:
                                                                            '12px 16px',
                                                                        backgroundColor:
                                                                            '#333',
                                                                        color: '#fff',
                                                                    },
                                                                },
                                                            }}
                                                        >
                                                            <InfoIcon
                                                                style={{
                                                                    color: '#DFDFDF',
                                                                }}
                                                                fontSize="small"
                                                            />
                                                        </Tooltip>
                                                    </div>
                                                }
                                            />
                                        )
                                    )}
                                </FormGroup>
                            )}

                            {!newProject && (
                                <FormGroup>
                                    {projectById?.documents
                                        ?.filter(
                                            (docType) =>
                                                docType.status === 'NOT_STARTED'
                                        )
                                        .map((docType) => (
                                            <FormControlLabel
                                                key={docType.document_type}
                                                control={
                                                    <Checkbox
                                                        checked={
                                                            selectedDocumentsType?.includes(
                                                                docType.document_type
                                                            ) || false
                                                        }
                                                        onChange={(e) => {
                                                            console.log(
                                                                'Checkbox changed:',
                                                                docType.id,
                                                                e.target.checked
                                                            )
                                                            handleDocumentTypeChange(
                                                                docType.document_type
                                                            )

                                                            if (
                                                                !selectedDocumentsType.includes(
                                                                    docType.document_type
                                                                )
                                                            ) {
                                                                let dependenciesToPass:
                                                                    | string[]
                                                                    | undefined =
                                                                    undefined

                                                                if (
                                                                    docType.depends_on &&
                                                                    docType
                                                                        .depends_on
                                                                        .length >
                                                                        0 &&
                                                                    selectedProject?.documents
                                                                ) {
                                                                    dependenciesToPass =
                                                                        docType.depends_on.filter(
                                                                            (
                                                                                depId
                                                                            ) => {
                                                                                const dependentDocInfo =
                                                                                    selectedProject.documents.find(
                                                                                        (
                                                                                            d
                                                                                        ) =>
                                                                                            d.document_type ===
                                                                                            depId
                                                                                    )

                                                                                return (
                                                                                    !dependentDocInfo ||
                                                                                    dependentDocInfo.status ===
                                                                                        'NOT_STARTED'
                                                                                )
                                                                            }
                                                                        )
                                                                } else {
                                                                    dependenciesToPass =
                                                                        docType.depends_on
                                                                }

                                                                handleDocumentTypeChange(
                                                                    docType.document_type,
                                                                    dependenciesToPass
                                                                )
                                                            }
                                                        }}
                                                    />
                                                }
                                                label={
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems:
                                                                'center',
                                                            gap: '4px',
                                                        }}
                                                    >
                                                        {docType.name}
                                                        <Tooltip
                                                            title={
                                                                docType.name.includes(
                                                                    'ETP'
                                                                )
                                                                    ? 'O Estudo Técnico Preliminar, conforme o artigo 6º, inciso XX, da Lei nº 14.133/2021, é um documento crucial na fase inicial do planejamento de contratações públicas. Ele serve para identificar e caracterizar o interesse público e selecionar a solução mais adequada para a necessidade governamental. O principal objetivo do ETP é fornecer base sólida para a construção do anteprojeto, termo de referência ou projeto básico, se a contratação for julgada viável.'
                                                                    : docType.name.includes(
                                                                            'DFD'
                                                                        )
                                                                      ? 'O Documento de Fluxo de Dados é um instrumento técnico essencial em diversas disciplinas, como a engenharia de software, gerência de projetos e análise de sistemas. Ele serve para mapear, visualizar e compreender o fluxo de informações dentro de processos ou sistemas, ilustrando como os dados se movem entre fontes e destinos.'
                                                                      : docType.name.includes(
                                                                              'TR'
                                                                          )
                                                                        ? 'O Termo de Referência é um documento fundamental no processo de contratações públicas, utilizado principalmente para a aquisição de bens e serviços. Serve como base detalhada para a preparação de licitações e contratos, descrevendo especificamente o que a Administração Pública pretende contratar.'
                                                                        : docType.name.includes(
                                                                                'Documento'
                                                                            )
                                                                          ? 'Documento genérico que pode ser utilizado para diversas finalidades dentro do processo de contratação pública, fornecendo informações específicas conforme a necessidade do projeto.'
                                                                          : docType.name.includes(
                                                                                  'Ata'
                                                                              )
                                                                            ? 'A Ata é um documento oficial que registra de forma resumida e clara os principais pontos discutidos e as decisões tomadas em reuniões, assembleias ou outros eventos formais.'
                                                                            : docType.name.includes(
                                                                                    'Contrato'
                                                                                )
                                                                              ? 'O Contrato é um documento jurídico que estabelece direitos e obrigações entre as partes, definindo termos, condições, prazos e responsabilidades para a execução de serviços ou fornecimento de bens.'
                                                                              : 'Documento adicional do projeto'
                                                            }
                                                            componentsProps={{
                                                                tooltip: {
                                                                    sx: {
                                                                        maxWidth:
                                                                            '400px',
                                                                        fontSize:
                                                                            '14px',
                                                                        padding:
                                                                            '12px 16px',
                                                                        backgroundColor:
                                                                            '#333',
                                                                        color: '#fff',
                                                                    },
                                                                },
                                                            }}
                                                        >
                                                            <InfoIcon
                                                                style={{
                                                                    color: '#DFDFDF',
                                                                }}
                                                                fontSize="small"
                                                            />
                                                        </Tooltip>
                                                    </div>
                                                }
                                            />
                                        ))}
                                </FormGroup>
                            )}

                            <Typography
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    textAlign: 'start',
                                }}
                            >
                                <img
                                    src={Coins}
                                    alt="Coins"
                                    style={{
                                        borderRadius: '8px',
                                        maxWidth: '50%',
                                        height: 'auto',
                                    }}
                                />
                                Gerar esses documentos irá consumir{' '}
                                {newProject
                                    ? newSelectedDocumentsType?.length
                                    : selectedDocumentsType?.length || 0}{' '}
                                {selectedDocumentsType?.length > 1 || newProject
                                    ? 'Créditos'
                                    : 'Crédito'}
                            </Typography>
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            marginTop: '16px',
                        }}
                    >
                        {(newProject
                            ? newSelectedDocumentsType?.length
                            : selectedDocumentsType?.length || 0) >
                            limits.usages.projects.max -
                                limits.usages.projects.current && (
                            <Typography
                                variant="body2"
                                color="error"
                                style={{
                                    marginBottom: '8px',
                                    fontSize: '14px',
                                    textAlign: 'center',
                                }}
                            >
                                Créditos insuficientes. Você tem{' '}
                                {limits.usages.projects.max -
                                    limits.usages.projects.current}{' '}
                                créditos disponíveis.
                            </Typography>
                        )}
                        <Button
                            style={{
                                width: '100%',
                                backgroundColor: (
                                    newProject
                                        ? !documentName ||
                                          documentName.length < 3 ||
                                          documentName.length > 200 ||
                                          newSelectedDocumentsType.length ===
                                              0 ||
                                          isCreatingProject ||
                                          newSelectedDocumentsType.length >
                                              limits.usages.projects.max -
                                                  limits.usages.projects.current
                                        : selectedDocumentsType.length < 1 ||
                                          isCreatingProject ||
                                          selectedDocumentsType.length >
                                              limits.usages.projects.max -
                                                  limits.usages.projects.current
                                )
                                    ? COLORS.cinzaClaro
                                    : COLORS.primariaEscura,
                                color: '#fff',
                            }}
                            variant="contained"
                            onClick={() => {
                                setViewResume(false)
                                handleConfirm()
                            }}
                            disabled={
                                newProject
                                    ? !documentName ||
                                      documentName.length < 3 ||
                                      documentName.length > 200 ||
                                      newSelectedDocumentsType.length === 0 ||
                                      isCreatingProject ||
                                      newSelectedDocumentsType.length >
                                          limits.usages.projects.max -
                                              limits.usages.projects.current
                                    : selectedDocumentsType.length < 1 ||
                                      isCreatingProject ||
                                      selectedDocumentsType.length >
                                          limits.usages.projects.max -
                                              limits.usages.projects.current
                            }
                            sx={{textTransform: 'none'}}
                        >
                            Criar documento
                        </Button>
                        {}
                    </div>
                    {(newProject
                        ? newSelectedDocumentsType.length
                        : selectedDocumentsType.length) >
                        limits.usages.projects.max -
                            limits.usages.projects.current && (
                        <Typography
                            variant="body2"
                            color="error"
                            style={{
                                color: '#d32f2f',
                                fontSize: '14px',
                                fontWeight: '500',
                                textAlign: 'center',
                                marginTop: '8px',
                            }}
                        >
                            Sem créditos suficientes para gerar os documentos
                        </Typography>
                    )}
                </ModalContent>
            </Modal>
            <Modal
                open={isCloneModalOpen}
                onClose={handleCloseCloneModal}
                onKeyDown={(event: any) => {
                    const disabled =
                        !cloneProjectName ||
                        cloneProjectName.length < 3 ||
                        cloneProjectName.length > 190 ||
                        cloneSelectedDocuments.length === 0 ||
                        isCreatingProject

                    if (event.key === 'Enter' && !disabled) {
                        cloneProject()
                    }
                }}
            >
                <ModalContent>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '16px',
                        }}
                    >
                        <Typography
                            variant="h6"
                            gutterBottom
                            sx={{fontSize: '16px'}}
                        >
                            Clonar Projeto
                        </Typography>
                        <IconButton onClick={handleCloseCloneModal}>
                            <CloseIcon />
                        </IconButton>
                    </div>

                    <Typography
                        variant="subtitle1"
                        sx={{fontSize: '14px'}}
                        gutterBottom
                    >
                        Nome do novo projeto
                    </Typography>
                    <input
                        placeholder="Nome do projeto"
                        title="Nome do projeto"
                        type="text"
                        value={cloneProjectName}
                        onChange={(e) => setCloneProjectName(e.target.value)}
                        style={{
                            width: '100%',
                            padding: '8px',
                            borderRadius: '4px',
                            border: '1px solid #ccc',
                            fontSize: '16px',
                            marginBottom: '16px',
                        }}
                        autoFocus
                    />

                    {cloneProjectName.length > 0 &&
                        cloneProjectName.length < 3 && (
                            <span
                                style={{
                                    color: 'red',
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block',
                                }}
                            >
                                O nome do projeto deve ter no mínimo 3
                                caracteres.
                            </span>
                        )}

                    {cloneProjectName.length > 190 && (
                        <span
                            style={{
                                color: 'red',
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block',
                            }}
                        >
                            O nome do projeto deve ter no máximo 190 caracteres.
                        </span>
                    )}

                    <Typography
                        variant="subtitle1"
                        sx={{fontSize: '14px', marginTop: '16px'}}
                        gutterBottom
                    >
                        Selecione os documentos para clonar
                    </Typography>

                    <FormGroup>
                        {projectToClone?.documents
                            .filter((doc) => doc.status === 'FINISHED')
                            .map((doc) => (
                                <FormControlLabel
                                    key={doc.document_type}
                                    control={
                                        <Checkbox
                                            checked={cloneSelectedDocuments.includes(
                                                doc.document_type
                                            )}
                                            onChange={() =>
                                                handleCloneDocumentToggle(
                                                    doc.document_type
                                                )
                                            }
                                        />
                                    }
                                    label={
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                            }}
                                        >
                                            <ArticleOutlinedIcon fontSize="small" />
                                            {doc.name}
                                        </div>
                                    }
                                />
                            ))}
                    </FormGroup>

                    {projectToClone?.documents.filter(
                        (doc) => doc.status === 'FINISHED'
                    ).length === 0 && (
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            style={{marginTop: '8px', fontSize: '14px'}}
                        >
                            Nenhum documento finalizado disponível para clonar.
                        </Typography>
                    )}

                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            marginTop: '24px',
                            gap: '8px',
                        }}
                    >
                        <Button
                            variant="outlined"
                            onClick={handleCloseCloneModal}
                            sx={{textTransform: 'none'}}
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            onClick={cloneProject}
                            disabled={
                                !cloneProjectName ||
                                cloneProjectName.length < 3 ||
                                cloneProjectName.length > 190 ||
                                cloneSelectedDocuments.length === 0 ||
                                isCreatingProject
                            }
                            style={{
                                backgroundColor:
                                    !cloneProjectName ||
                                    cloneProjectName.length < 3 ||
                                    cloneProjectName.length > 190 ||
                                    cloneSelectedDocuments.length === 0 ||
                                    isCreatingProject
                                        ? COLORS.cinzaClaro
                                        : COLORS.primariaEscura,
                                color: '#fff',
                            }}
                            sx={{textTransform: 'none'}}
                        >
                            {isCreatingProject
                                ? 'Clonando....'
                                : 'Clonar Projeto'}
                        </Button>
                    </div>
                </ModalContent>
            </Modal>
            {openAlertErro && (
                <Alert
                    style={{alignSelf: 'flex-end'}}
                    variant="filled"
                    severity="error"
                    onClose={() => {
                        setOpenAlertErro(false)
                    }}
                >
                    Seus Créditos para gerar documentos acabaram
                </Alert>
            )}
            {_desarquivarModal()}
        </Page>
    )
}
